export default interface IMake {
    value: boolean;
    Name: string;
    LciId: number;
    Id: string;
    Priority: number;
}

export class Make {
    value: boolean;
    Name: string;
    LciId: number;
    Id: string;
    Priority: number;

    constructor(value: boolean, name: string, lciid: number, id: string, priority: number) {
        this.value = value;
        this.Name = name;
        this.LciId = lciid;
        this.Id = id;
        this.Priority = priority;
    }

    public static copy(make: IMake) {
        return new Make(make.value, make.Name, make.LciId, make.Id, make.Priority);
    }
}